import { render, staticRenderFns } from "./WidgetMenu.vue?vue&type=template&id=2b49b293&scoped=true"
import script from "./WidgetMenu.vue?vue&type=script&lang=js"
export * from "./WidgetMenu.vue?vue&type=script&lang=js"
import style0 from "./WidgetMenu.vue?vue&type=style&index=0&id=2b49b293&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b49b293",
  null
  
)

export default component.exports